<div role="dialog" class="add-dialog">

    <app-stepper [steps]="steps" title="{{'OPEN_CASE' | translate}}"></app-stepper>

    <div class="add-item" [class.cutter-addCase]="hasCutter" aria-labelledby="title">

        <div class="item-detail" id="item-detail">
            <div class="pages">



                <!-- Page 1 -->
                <div class="page-1" *ngIf="pageNumber ===1" id="step1" role="tabpanel">


                    <ng-container *ngIf="!hasCutter">
                        <span class="page-header">{{'DEVICE_INFO' | translate}}</span><br>
                        <!-- <span class="sub-header" id="sub-header1">{{'ADD_CASE.SUB_1' | translate}}</span> -->
                    </ng-container>

                    <ng-container *ngIf="hasCutter">
                        <span class="page-header">{{'DEVICE_INFO' | translate}}</span><br>
                        <!-- <span class="sub-header" id="sub-header1">{{'INTRO_CASE_INFO' | translate}}</span> -->
                    </ng-container>

                    <div class="page-data">
                        <ng-container>
                            <div class="data-item">
                                <div class="item-label">{{'ADD_CASE.COMPANY' | translate }}*</div>
                                <div class="form-item">
                                    <app-hp-dropdown [data]="companyDropdown" [listStatus]="companyStatus"
                                        [inputPlaceHolder]="'ADD_CASE.COMPANY_SEARCH' | translate" [searchable]="true"
                                        [list]="customerList" [selectedOption]="selectedCompany"
                                        (setValue)="selectedValue('company',$event)"
                                        (isOpen)="dropStatus('company', $event)" [disabled]="disabledCompany"
                                        [clearIcon]="true"></app-hp-dropdown>
                                </div>
                            </div>
                            <hr class="light-stroke" aria-hidden="true">
                        </ng-container>
                        <ng-container *ngIf="hasCutter">
                            <div class="data-item">
                                <div class="item-label">{{'DEVICE_TYPE' | translate }}*</div>

                                <div class="form-item">
                                    <app-hp-dropdown [data]="deviceDropdown" [searchable]="false"
                                        [list]="deviceTypeList" [selectedOption]="selectedDeviceType"
                                        (setValue)="selectedValue('deviceType',$event)"
                                        [clearIcon]="true"></app-hp-dropdown>

                                </div>
                            </div>
                            <hr class="light-stroke" aria-hidden="true">
                        </ng-container>
                        <!-- merge page-2 hasCutter -->
                        <ng-container *ngIf="hasCutter">

                            <div *ngIf="this.selectedDeviceType[0]?.value == 'Printer and cutter'">
                                <!-- PROBLEM_LOCATION -->
                                <ng-container>

                                    <div class="data-item">
                                        <div class="item-label">{{'PROBLEM_LOCATION' | translate }}*</div>
                                        <div class="form-item">
                                            <app-hp-dropdown [data]="problemLocDropdown" [searchable]="false"
                                                [list]="problemLocationList" [selectedOption]="selectedProblemLoc"
                                                (setValue)="selectedValue('problemLocation',$event)"
                                                [clearIcon]="true"></app-hp-dropdown>
                                        </div>
                                    </div>
                                    <hr class="light-stroke" aria-hidden="true">
                                </ng-container>
                            </div>
                            <!-- DEVICE MODEL -->
                            <ng-container>

                                <div class="data-item">
                                    <div class="item-label">{{'DEVICE_MODEL' | translate }}*</div>
                                    <div class="form-item">
                                        <app-hp-dropdown [data]="printerDropdown"
                                            [inputPlaceHolder]="'DEVICE_MODEL_SEARCH' | translate"
                                            [listStatus]="modelStatus" [searchable]="true" [list]="printerList"
                                            [selectedOption]="selectedPrinter"
                                            (setValue)="selectedValue('printer',$event)"
                                            (isOpen)="dropStatus('printer', $event)" [disabled]="disabledPrinter"
                                            [clearIcon]="true"></app-hp-dropdown>
                                    </div>
                                </div>

                                <hr class="light-stroke" aria-hidden="true">

                            </ng-container>
                            <div *ngIf="this.selectedDeviceType[0]?.value == 'Printer'">
                                <!-- DEVICE_FUCNTIONING -->
                                <ng-container>

                                    <div class="data-item">
                                        <div class="item-label">{{'DEVICE_FUCNTIONING' | translate }}*</div>
                                        <div class="form-item">

                                            <app-hp-dropdown [data]="printerFuncDropdown" [listStatus]="functionStatus"
                                                [searchable]="false" [list]="printerFunctioning"
                                                [selectedOption]="selectedPrinterFunc"
                                                (setValue)="selectedValue('printfunc',$event)"
                                                (isOpen)="dropStatus('func', $event)"
                                                [clearIcon]="true"></app-hp-dropdown>
                                        </div>
                                    </div>
                                    <hr class="light-stroke" aria-hidden="true">
                                </ng-container>
                            </div>
                            <!-- DEVICE_FUCNTIONING BASED PROBLEM LOCATION-->
                            <div *ngIf="this.selectedDeviceType[0]?.value == 'Printer and cutter'">

                                <ng-container *ngIf="selectedProblemLoc[0]?.value != 'Printer'">

                                    <div class="data-item">
                                        <div class="item-label">{{'DEVICE_FUCNTIONING' | translate }}*</div>
                                        <div class="form-item">

                                            <app-hp-dropdown [data]="deviceFuncDropdown" [searchable]="false"
                                                [disabled]="selectedProblemLoc[0]?.value != 'Cutter'"
                                                [list]="deviceFunctioning" [selectedOption]="selectedDeviceFunc"
                                                (setValue)="selectedValue('deviceFunc',$event)"
                                                [clearIcon]="true"></app-hp-dropdown>
                                        </div>
                                    </div>
                                    <hr class="light-stroke" aria-hidden="true">
                                </ng-container>
                                <ng-container *ngIf="selectedProblemLoc[0]?.value == 'Printer'">

                                    <div class="data-item">
                                        <div class="item-label">{{'DEVICE_FUCNTIONING' | translate }}*</div>
                                        <div class="form-item">
                                            <app-hp-dropdown [data]="printerFuncDropdown" [searchable]="false"
                                                [disabled]="selectedProblemLoc[0]?.value != 'Printer'"
                                                [list]="printerFunctioningCopy"
                                                [selectedOption]="selectedPrinterFuncCopy"
                                                (setValue)="selectedValue('printerFunctioningCopy',$event)"
                                                [clearIcon]="true"></app-hp-dropdown>
                                        </div>
                                    </div>
                                    <hr class="light-stroke" aria-hidden="true">

                                </ng-container>
                            </div>


                            <div *ngIf="this.selectedDeviceType[0]?.value == 'Cutter'">
                                <!-- DEVICE_FUCNTIONING -->
                                <ng-container>

                                    <div class="data-item">
                                        <div class="item-label">{{'DEVICE_FUCNTIONING' | translate }}*</div>
                                        <div class="form-item">
                                            <app-hp-dropdown [data]="deviceFuncDropdown" [searchable]="false"
                                                [list]="deviceFunctioning" [selectedOption]="selectedDeviceFunc"
                                                (setValue)="selectedValue('deviceFunc',$event)"
                                                [clearIcon]="true"></app-hp-dropdown>
                                        </div>
                                    </div>
                                    <hr class="light-stroke" aria-hidden="true">
                                </ng-container>
                            </div>
                        </ng-container>
                        <!-- end page 2 cutter -->

                        <ng-container *ngIf="!hasCutter">
                            <ng-container>

                                <div class="data-item">
                                    <div class="item-label">{{'DEVICE_MODEL' | translate }}*</div>
                                    <div class="form-item">

                                        <app-hp-dropdown [data]="printerDropdown"
                                            [inputPlaceHolder]="'DEVICE_MODEL_SEARCH' | translate"
                                            [listStatus]="modelStatus" [searchable]="true" [list]="printerList"
                                            [selectedOption]="selectedPrinter"
                                            (setValue)="selectedValue('printer',$event)"
                                            (isOpen)="dropStatus('printer', $event)" [disabled]="disabledPrinter"
                                            [clearIcon]="true"></app-hp-dropdown>
                                    </div>
                                </div>
                                <hr class="light-stroke" aria-hidden="true">
                            </ng-container>
                            <ng-container>

                                <div class="data-item">
                                    <div class="item-label">{{'DEVICE_FUCNTIONING' | translate }}*</div>
                                    <div class="form-item">

                                        <app-hp-dropdown [data]="printerFuncDropdown" [listStatus]="functionStatus"
                                            [searchable]="false" [list]="printerFunctioning"
                                            [selectedOption]="selectedPrinterFunc"
                                            (setValue)="selectedValue('printfunc',$event)"
                                            (isOpen)="dropStatus('func', $event)" [clearIcon]="true"></app-hp-dropdown>
                                    </div>
                                </div>
                                <hr class="light-stroke" aria-hidden="true">
                            </ng-container>

                        </ng-container>



                    </div>


                </div>



                <div class="page-2" *ngIf="pageNumber === 2" id="step2" role="tabpanel">

                    <span class="page-header">{{'ADD_CASE.STEP_2' | translate}}</span><br>
                    <!-- <span class="sub-header" id="sub-header3">{{'INTRO_CASE' | translate}}</span> -->

                    <div class="page-data">
                        <!-- actual dropdown to be set here -->
                        <div [hidden]="this.dialogData?.proactive == 'proactive'">
                            <div
                                [hidden]="selectedProblemLoc[0]?.value == 'Cutter' || this.selectedDeviceType[0]?.value == 'Cutter'">

                                <div class="data-item">
                                    <div class="item-label">{{'ADD_CASE.CASE' | translate }}*</div>
                                    <div class="form-item">

                                        <!-- printer case type list -->
                                        <app-hp-dropdown [data]="caseTypeDropdown" [listStatus]="typeStatus"
                                            [searchable]="false" [list]="caseTypeList" [selectedOption]="selectedCase"
                                            (setValue)="selectedValue('case',$event)"
                                            (isOpen)="dropStatus('case', $event)" [disabled]="disabledCase"
                                            [clearIcon]="true"></app-hp-dropdown>
                                    </div>
                                </div>
                                <hr class="light-stroke" aria-hidden="true">

                            </div>
                            <ng-container
                                *ngIf="selectedProblemLoc[0]?.value == 'Cutter' || this.selectedDeviceType[0]?.value == 'Cutter'">
                                <div class="data-item">
                                    <div class="item-label">{{'ADD_CASE.CASE' | translate }}*</div>
                                    <div class="form-item">
                                        <!-- cutter case type list -->
                                        <app-hp-dropdown [data]="caseTypeDropdown" [searchable]="false"
                                            [list]="cutterCaseTypeList" [selectedOption]="selectedCutterCaseType"
                                            (setValue)="selectedValue('cutterCaseType',$event)"
                                            [clearIcon]="true"></app-hp-dropdown>
                                    </div>
                                </div>
                                <hr class="light-stroke" aria-hidden="true">

                            </ng-container>
                        </div>


                        <ng-container *ngIf="this.dialogData?.proactive == 'proactive'">

                            <div class="data-item">
                                <div class="item-label">{{'ADD_CASE.CASE' | translate }}*</div>
                                <div class="form-item">

                                    <app-hp-dropdown [data]="caseTypeDropdown" [searchable]="false" [list]="legendsList"
                                        [selectedOption]="selectedCaseType" (setValue)="selectedLegend($event)"
                                        [disabled]="true" [clearIcon]="true"></app-hp-dropdown>
                                </div>
                            </div>
                            <hr class="light-stroke" aria-hidden="true">

                        </ng-container>

                        <ng-container *ngIf="getStatus('target')">

                            <div class="data-item">
                                <div class="item-label">{{'TARGETED_ACTIONS_TYPE' | translate }}*</div>
                                <div class="form-item">
                                    <app-hp-dropdown [data]="targetedDropdown" [searchable]="false" [list]="targetList"
                                        [selectedOption]="selectedTarget" (setValue)="selectedValue('target',$event)"
                                        [clearIcon]="true" [multi]="false" [autoClose]="true"></app-hp-dropdown>
                                </div>
                            </div>
                            <hr class="light-stroke" aria-hidden="true">

                        </ng-container>


                        <ng-container *ngIf="getStatus('maint')">

                            <div class="data-item">
                                <div class="item-label">{{'MAINTENANCE_TASK' | translate }}*</div>

                                <div class="form-item">

                                    <app-hp-dropdown [data]="maintenanceDropdown" [listStatus]="typeStatus"
                                        [searchable]="false" [list]="maintenanceList" [selectedOption]="selectedCase"
                                        (setValue)="selectedValue('maint',$event)" [clearIcon]="true" [multi]="false"
                                        [autoClose]="true"></app-hp-dropdown>
                                </div>

                            </div>
                            <hr class="light-stroke" aria-hidden="true">

                        </ng-container>
                        <ng-container *ngIf="getStatus('bnf')">

                            <div class="data-item">
                                <div class="item-label">{{'ADD_CASE.ERROR' | translate }}*</div>
                                <div class="form-item">

                                    <app-hp-dropdown [data]="errorCodeDropdown" [listStatus]="errorStatus"
                                        [searchable]="errorCodeList?.length > 6" [list]="errorCodeList"
                                        [selectedOption]="selectedErrorCode" (setValue)="selectedValue('error',$event)"
                                        (isOpen)="dropStatus('error', $event)" [disabled]="disabledCase"
                                        [clearIcon]="true" [multi]="false" [autoClose]="true"
                                        [selectionSeparation]="false"
                                        [inputPlaceHolder]="'HP_DROP_DOWN.LIST_SEARCH_PLACE' | translate"></app-hp-dropdown>
                                </div>
                            </div>
                            <hr class="light-stroke" aria-hidden="true">

                        </ng-container>

                        <!-- start -->
                        <!-- text boxes for subject and detail -->
                        <form [formGroup]="page1Form">
                            <ng-container>

                                <div class="data-item">
                                    <div class="item-label">{{'ADD_CASE.SUBJECT' | translate }}*</div>

                                    <div class="form-item textbox">
                                        <app-hp-text-box [fieldHasValue]="fieldHasValue('subject')" [ariaLabel]="true"
                                            formControlName="subject" [options]="subjectData"
                                            [hasRequiredError]="this.page1Form.get('subject').touched && this.page1Form.get('subject').hasError('required')"
                                            [hasPatternError]="this.page1Form.get('subject').touched && this.page1Form.controls.subject.errors?.pattern">
                                        </app-hp-text-box>
                                    </div>
                                </div>
                                <hr class="light-stroke" aria-hidden="true">

                            </ng-container>
                            <ng-container>

                                <div class="data-item">
                                    <div class="item-label">{{'ADD_CASE.DETAIL' | translate }}*</div>
                                    <div class="form-item textbox">
                                        <app-hp-text-box [fieldHasValue]="fieldHasValue('detail')" [ariaLabel]="true"
                                            formControlName="detail" [options]="detailData"
                                            [hasRequiredError]="this.page1Form.get('detail').touched && this.page1Form.get('detail').hasError('required')">
                                        </app-hp-text-box>
                                    </div>
                                </div>
                                <hr class="light-stroke" aria-hidden="true">

                            </ng-container>

                        </form>
                        <!-- optional fields -->
                        <ng-container>

                            <div class="data-item">
                                <div class="item-label">{{'ADD_CASE.CASE_CONTACT' | translate }}</div>
                                <div class="form-item">

                                    <!-- add optional text for options and job title -->
                                    <app-hp-dropdown [data]="caseContact" [listStatus]="contactStatus"
                                        [searchable]="true" [list]="caseContactList" [selectedOption]="selectedContact"
                                        (setValue)="selectedValue('contact',$event)"
                                        (isOpen)="dropStatus('contact', $event)"
                                        [inputPlaceHolder]="'HP_DROP_DOWN.LIST_SEARCH_PLACE' | translate"
                                        [hideError]="true" [clearIcon]="true"></app-hp-dropdown>
                                </div>
                            </div>
                            <hr class="light-stroke" aria-hidden="true">

                        </ng-container>

                        <!-- new customer details comes here -->
                        <form [formGroup]="customerDetailForm" *ngIf="isNewContact">
                            <ng-container>

                                <div class="data-item">
                                    <div class="item-label">{{'ADD_CASE.LAST_NAME' | translate }}*</div>
                                    <div class="form-item textbox">
                                        <app-hp-text-box [fieldHasValue]="customerData('lname')" formControlName="lname"
                                            [ariaLabel]="true" [options]="lnameData"
                                            [hasRequiredError]="this.customerDetailForm.get('lname').touched && this.customerDetailForm.get('lname').hasError('required')">
                                        </app-hp-text-box>
                                    </div>
                                </div>
                                <hr class="light-stroke" aria-hidden="true">
                            </ng-container>
                            <ng-container>

                                <div class="data-item">
                                    <div class="item-label">{{'ADD_CASE.EMAIL' | translate }}*</div>
                                    <div class="form-item textbox">
                                        <app-hp-text-box [fieldHasValue]="customerData('email')" formControlName="email"
                                            [ariaLabel]="true" [options]="emailData"
                                            [hasRequiredError]="this.customerDetailForm.get('email').touched && this.customerDetailForm.get('email').hasError('required')"
                                            [hasPatternError]="this.customerDetailForm.get('email').touched && this.customerDetailForm.controls.email.errors?.pattern">
                                        </app-hp-text-box>
                                    </div>
                                </div>
                                <hr class="light-stroke" aria-hidden="true">
                            </ng-container>
                            <ng-container>

                                <div class="data-item">
                                    <div class="item-label">{{'ADD_CASE.PHONE_NUMBER' | translate }}*</div>
                                    <div class="form-item textbox">
                                        <app-hp-text-box [fieldHasValue]="customerData('phone')" formControlName="phone"
                                            [ariaLabel]="true" [options]="phoneData"
                                            [hasRequiredError]="this.customerDetailForm.get('phone').touched && this.customerDetailForm.get('phone').hasError('required')"
                                            [hasPatternError]="this.customerDetailForm.get('phone').touched && this.customerDetailForm.controls.phone.errors?.pattern">
                                        </app-hp-text-box>
                                    </div>
                                </div>
                                <hr class="light-stroke" aria-hidden="true">
                            </ng-container>
                            <ng-container>

                                <div class="data-item">
                                    <div class="item-label">{{'ADD_CASE.FIRST_NAME' | translate }}*</div>
                                    <div class="form-item textbox">
                                        <app-hp-text-box [fieldHasValue]="customerData('fname')" formControlName="fname"
                                            [ariaLabel]="true" [options]="fnameData"
                                            [hasRequiredError]="this.customerDetailForm.get('fname').touched && this.customerDetailForm.get('fname').hasError('required')">
                                        </app-hp-text-box>
                                    </div>
                                </div>
                                <hr class="light-stroke" aria-hidden="true">
                            </ng-container>
                            <ng-container>

                                <div class="data-item">
                                    <div class="item-label">{{'ADD_CASE.JOB_TITLE' | translate }}*</div>
                                    <div class="form-item">

                                        <app-hp-dropdown [data]="jobDropdown" [listStatus]="jobStatus"
                                            [searchable]="false" [list]="jobList" [selectedOption]="selectedJob"
                                            (setValue)="selectedValue('job',$event)"
                                            (isOpen)="dropStatus('job', $event)" [clearIcon]="true"></app-hp-dropdown>
                                    </div>
                                </div>
                                <hr class="light-stroke" aria-hidden="true">
                            </ng-container>
                        </form>



                        <ng-container>
                            <div class="data-item">
                                <div class="item-label">{{'ADD_CASE.ASSIGN_TO' | translate }}</div>
                                <div class="form-item">

                                    <app-hp-dropdown [data]="assignDropdown" [listStatus]="assignStatus"
                                        [searchable]="true" [list]="assingToList" [selectedOption]="selectedAssignee"
                                        (setValue)="selectedValue('assign',$event)"
                                        (isOpen)="dropStatus('assign', $event)"
                                        [inputPlaceHolder]="'HP_DROP_DOWN.LIST_SEARCH_PLACE' | translate"
                                        [hideError]="true" [clearIcon]="true"></app-hp-dropdown>
                                </div>
                            </div>
                            <hr class="light-stroke" aria-hidden="true">
                        </ng-container>


                    </div>
                </div>


            </div>

            <div class="footer" [ngStyle]="(isLoading || showVeenerLoader)?{'pointer-events': 'none'} : ''">
                <div *ngIf="isLoading">
                    <mat-spinner [diameter]="35"></mat-spinner>
                </div>
                <div>
                    <button id="add-case-dialog-close-btn" (click)="close()"
                        class="hp-tertiary-btn cancel btn-space-left focusable">{{'ADD_CASE.BTN_CANCEL' |
                        translate}}</button>
                </div>
                <div *ngIf="isPreviousButtonHidden">
                    <button id="add-case-dialog-prev-btn" (click)="loadPreviousPage()"
                        class="hp-secondary-btn btn-space-left show-lg-screen">
                        <img class="rotate arrow-right arrow-img" src="./assets/icons/arrow-right-primary.svg"
                            alt="">{{'ADD_CASE.BTN_BACK' | translate}}</button>
                    <button class="hp-secondary-btn action-btn-space-left hide-lg-screen" (click)="loadPreviousPage()">
                        <img class="rotate arrow-right arrow-img" src="./assets/icons/arrow-right-primary.svg" alt="">
                    </button>
                </div>
                <div *ngIf="!showVeenerLoader;else veenerLoaderView">
                    <button id="add-case-dialog-next-btn" (click)="loadNextPage()"
                        class="hp-primary-btn btn-space-left show-lg-screen" [disabled]="isButtonDisabled"
                        [class.hp-disabled-btn]="isButtonDisabled">
                        <span *ngIf="pageNumber === 1">{{'ADD_CASE.BTN_NXT' |
                            translate}}</span>
                        <span *ngIf="pageNumber === 2">{{'BUTTONS.SUBMIT' | translate}}</span>
                        <img class="arrow-img arrow-right" src="./assets/icons/arrow-right-white.svg" alt=""></button>
                    <button class="hp-primary-btn action-btn-space-left hide-lg-screen" (click)="loadNextPage()"
                        [disabled]="isButtonDisabled" [class.hp-disabled-btn]="isButtonDisabled">
                        <img class="arrow-img" src="./assets/icons/arrow-right-white.svg" alt="">
                    </button>
                </div>
                <ng-template #veenerLoaderView>
                    <div class="btn-space-left">
                        <app-veener-loader-btn></app-veener-loader-btn>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</div>